export function getColorForDataset(datasets, datasetId) {
  const datasetIndex = datasets.findIndex((d) => d.id === datasetId)
  return ['red', 'yellow', 'aqua'][datasetIndex]
}
